import React, { useEffect, useState } from 'react';
import { Button } from 'components/Form';
import { ReactComponent as DownloadIcon } from 'assets/icons/Download.svg';
import { SvgIcon } from '@mui/material';
import { InstallButtonStyles } from './Style'

const InstallButton = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowButton(true);
        });
    }, []);

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                console.log('User accepted the A2HS prompt');
            }
            setDeferredPrompt(null);
            setShowButton(false);
        }
    };

    return (
        <InstallButtonStyles>
            {showButton && (
                <React.Fragment>
                    <div>
                        <div>
                            {"רוצה לעבוד גם בלי דפדפן?"}
                        </div>
                        <div>
                            {"הורד את גרסת המחשב שלנו"}
                        </div>
                    </div>
                    <Button
                        variant="regular"
                        color={"thirdly1"}
                        action={handleInstallClick}
                    >
                        {"הורד גרסת מחשב"}
                        <SvgIcon component={DownloadIcon} inheritViewBox />
                    </Button>
                </React.Fragment>
            )}
        </InstallButtonStyles>
    );
};

export default InstallButton;